import api, { integrationsApi } from '../utils/api';

export const shopifyService = {
  // Valider les identifiants et récupérer un token
  validateCredentials: async (shopDomain, accessToken) => {
    try {
      return await integrationsApi.validateShopifyCredentials(shopDomain, accessToken);
    } catch (error) {
      console.error('Erreur lors de la validation des identifiants Shopify:', error);
      throw error;
    }
  },

  // Récupérer la liste des produits Shopify
  fetchProducts: async (shopDomain, accessToken, cursor = null) => {
    console.log('shopDomain', shopDomain);
    console.log('accessToken', accessToken);  
    console.log('cursor', cursor); 
    try {
      return await integrationsApi.fetchShopifyProducts(shopDomain, accessToken, cursor);
    } catch (error) {
      console.error('Erreur lors de la récupération des produits Shopify:', error);
      throw error;
    }
  },

  // Importer les produits sélectionnés
  importProducts: async (shopDomain, accessToken, productIds) => {
    try {
      return await integrationsApi.importShopifyProducts(shopDomain, accessToken, productIds);
    } catch (error) {
      console.error('Erreur lors de l\'importation des produits Shopify:', error);
      throw error;
    }
  },

  // Récupérer les détails d'un produit avec ses variants
  fetchProductDetails: async (shopDomain, accessToken, productId) => {
    try {
      return await integrationsApi.fetchShopifyProductDetails(productId, shopDomain, accessToken);
    } catch (error) {
      console.error('Erreur lors de la récupération des détails du produit Shopify:', error);
      throw error;
    }
  }
};

export default shopifyService; 